import styled from "styled-components";
import { EaseDrawer } from "../../libs/EaseDrawer";

export const WebhookDrawerWrapper = styled(EaseDrawer)`
  .ant-drawer-body {
    height: calc(100% - 58px);

    > div {
      height: 100%;

      > .ant-spin-nested-loading,
      .ant-spin-container {
        height: 100%;
      }
    }
  }

  .ant-drawer-header {
    position: sticky;
    top: 0;
    z-index: 999;
  }

  .priority-input {
    width: 100px;
  }

  .rest-of-amt-text {
    font-style: italic;
  }

  .ant-table .ant-table-body .ant-table-row {
    cursor: auto;
  }
`;
